import { NavMenuItem } from '@liscio/common';
import { Icon, List } from '@liscio/ui';

import { LegalDocumentsMenuItem } from './components';
import { useFirmViewMode } from 'custom-hooks/useFirmViewMode';

export const SecondaryNavigationMenu = () => {
  const { isMobile } = useFirmViewMode();
  return (
    <>
      {!isMobile && <LegalDocumentsMenuItem />}
      {isMobile && (
        <List>
          <NavMenuItem
            icon={<Icon icon="logout" />}
            label="Logout"
            to="/authenticate/logout"
          />
        </List>
      )}
    </>
  );
};
